import type { ApolloClient } from "@apollo/client";
import { createStore, type ReadOnlyStore } from "@observe-tech/mfe-shell-api";
import type { Cage } from "@observe-tech/mfe-shell-api";
import { GET_CAGES_FOR_SITE } from "../graphql/cages.queries";

export interface CagesApi {
  listForSite(siteId: string): ReadOnlyStore<Cage[]>;
  refresh(siteId: string): Promise<void>;
}

export function createCagesApi(client: ApolloClient<unknown>): CagesApi {
  const cache = new Map<string, ReturnType<typeof createStore<Cage[]>>>();
  function getOrCreate(siteId: string) {
    let h = cache.get(siteId);
    if (!h) {
      h = createStore<Cage[]>([]);
      cache.set(siteId, h);
    }
    return h;
  }
  return {
    listForSite: (siteId) => getOrCreate(siteId).store,
    refresh: async (siteId) => {
      try {
        const r = await client.query<{ cagesForSite: Cage[] }>({
          query: GET_CAGES_FOR_SITE,
          variables: { siteId },
          fetchPolicy: "network-only",
        });
        getOrCreate(siteId).set(r.data.cagesForSite ?? []);
      } catch {
        getOrCreate(siteId).set([]);
      }
    },
  };
}
